import { CandleChart } from "../components/chart/CandleChart.js";
import { SignalPanel } from "../components/signals/SignalPanel.js";
import { SymbolSelector } from "../components/SymbolSelector.js";
import { useChartStore, type Exchange, type Timeframe } from "../lib/chartStore.js";

export function DashboardPage() {
  const symbol = useChartStore((s) => s.symbol);
  const exchange = useChartStore((s) => s.exchange);
  const timeframe = useChartStore((s) => s.timeframe);
  const setSymbol = useChartStore((s) => s.setSymbol);
  const setExchange = useChartStore((s) => s.setExchange);
  const setTimeframe = useChartStore((s) => s.setTimeframe);

  return (
    <div className="flex h-full flex-col">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 16px",
          borderBottom: "1px solid var(--border)",
        }}
      >
        <SymbolSelector
          symbol={symbol}
          exchange={exchange as Exchange}
          timeframe={timeframe as Timeframe}
          onSymbol={setSymbol}
          onExchange={setExchange}
          onTimeframe={setTimeframe}
        />
      </div>
      <div className="grid min-h-0 flex-1 grid-cols-[1fr_360px] grid-rows-[minmax(0,1fr)] overflow-hidden">
        <div
          className="min-h-0 min-w-0 overflow-hidden"
          style={{ borderRight: "1px solid var(--border)" }}
          data-testid="chart-container"
        >
          <CandleChart exchange={exchange} symbol={symbol} timeframe={timeframe} />
        </div>
        <div className="min-h-0 min-w-0 overflow-hidden">
          <SignalPanel />
        </div>
      </div>
    </div>
  );
}
